module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/465.74c56682.png";